<p-dialog
  [header]="!!dialogHeader ? dialogHeader : field.header + ' auswählen'"
  [modal]="true"
  [(visible)]="displayEntitySelectionDialog"
  [style]="{ width: '80%' }"
  appendTo="body"
>
  <div>
    <jml-lib-dynamic-table
      *ngIf="entitySelectionTableData"
      [tableData]="entitySelectionTableData"
      (entitySelection)="entitySelected($event)"
      [isRootEntity]="false"
      [activateTableState]="false"
    ></jml-lib-dynamic-table>
  </div>
</p-dialog>

<div class="cell-view">
  <div *ngIf="!isEntityDeleted; else deletedTpl" class="inner-view">
    <a [routerLink]="targetUrl$ | async" [queryParams]="targetParams$ | async"> {{ entityDisplayName }}</a>
  </div>
  <ng-template #deletedTpl>
    <div style="color: var(--gray-500)" class="inner-view">
      {{ entityDisplayName }}
    </div>
  </ng-template>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="EntityReferenceCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="EntityReferenceCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>
